export default {
  slug: "ide-services",
  code: "IS",
  label: "IDE Services",
  logoFamily: "jb",
};
